import { Reducer } from 'redux';
import {
  IMembershipCollection,
  IMembershipEdge,
} from 'stubs/graphql/membership';

import { MEMBERSHIP_ACTIONS, IMembershipActions } from './actions';

export interface IMembershipStore {
  all: IMembershipCollection;
  active: IMembershipEdge | null;
}

export const initialState: IMembershipStore = {
  all: { edges: [] },
  active: null,
};

// --------------
// Reducer
// --------------

export const membershipReducer: Reducer<IMembershipStore, IMembershipActions> =
  (state: IMembershipStore = initialState, action: IMembershipActions) => {
    switch (action.type) {
      case MEMBERSHIP_ACTIONS.UPDATE_RETRIEVE_ALL:
        return { ...state, all: action.all };
      case MEMBERSHIP_ACTIONS.UPDATE_RETRIEVE_ACTIVE:
        return { ...state, active: action.active };
      default:
        return state;
    }
  };
